import { isDefined } from '@sgme/fp';
import { useBlackoutDates } from 'components/common-form/hooks/useBlackoutDates';
import type { CalendarInfo } from 'models/forms/fields/DateFieldMetadata';
import { useMemo } from 'react';

const EMPTY_CALENDARS: CalendarInfo[] = [];

export function useSettlementBlackoutDates(calendars: CalendarInfo[] = EMPTY_CALENDARS) {
  const settlementCalendars = useMemo(
    () =>
      [...new Set(calendars.map(({ currency }) => currency))]
        .filter(isDefined)
        .map((currency): CalendarInfo => ({ currency, calendarType: 'Settlement', id: currency })),
    [calendars],
  );

  return useBlackoutDates(settlementCalendars);
}
